import { Box, styled } from "@mui/material";

export const CanvasBackgroundContainer = styled("div")(({ theme }) => ({
  color: "white",
  background: theme.palette.primary.main,
}));

export const CanvasContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  borderRadius: "5px",
}));
